import { render, staticRenderFns } from "./HealthAlert.vue?vue&type=template&id=2ea4f8c2&"
import script from "./HealthAlert.vue?vue&type=script&lang=js&"
export * from "./HealthAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ea4f8c2')) {
      api.createRecord('2ea4f8c2', component.options)
    } else {
      api.reload('2ea4f8c2', component.options)
    }
    module.hot.accept("./HealthAlert.vue?vue&type=template&id=2ea4f8c2&", function () {
      api.rerender('2ea4f8c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/HealthAlert.vue"
export default component.exports